module.exports = __webpack_public_path__ + "static/media/bg_servicos.f0556993.png";